import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style/carousel.css";
import "../atoms/style/button.css"
import CarouselImg from "../atoms/CarouselImg";
import NewInButton from "../atoms/new-in-button";

export default class Carousel extends Component {
	render() {
		var settings = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			speed: 2000,
			autoplaySpeed: 2000,
			cssEase: "linear",
			initialSlide: 0,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						initialSlide: 1,
					},
				},
			],
		};

		return (
			<div className="carousel-container">
				<NewInButton className="button"/>
				<Slider {...settings} className="carousel">
					<div>
						<CarouselImg className="carousel-images" />
					</div>
					{/* <div>
						<CoralImg className="carousel-images" />
					</div>
					<div>
						<VintageImg className="carousel-images" />
					</div> */}
				</Slider>
			</div>
		);
	}
}
